import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { WarningCircle } from "@phosphor-icons/react";
import api from "../../../lib/api";
import { apiError, inp, todayWIB } from "../util";
import DashDaily from "./DashDaily";
import DashMonthly from "./DashMonthly";
import Outstanding from "./Outstanding";

const VIEWS = [["daily", "Harian"], ["monthly", "Bulanan"], ["pending", "Menunggu persetujuan"]];

export default function ExecutiveDashboard() {
    const [view, setView] = useState("daily");
    const [date, setDate] = useState(todayWIB());
    const [month, setMonth] = useState(todayWIB().slice(0, 7));
    const [daily, setDaily] = useState(null);
    const [monthly, setMonthly] = useState(null);
    const [pending, setPending] = useState(null);
    const [busy, setBusy] = useState(false);

    const load = useCallback(async () => {
        try {
            if (view === "monthly") setMonthly((await api.get("/reporting/dashboard/monthly", { params: { month } })).data);
            else if (view === "pending") setPending((await api.get("/reporting/dashboard/pending")).data.items);
            else { const r = (await api.get("/reporting/dashboard/daily", { params: { date } })).data; setDaily(r); setPending(r.outstanding); }
        } catch (e) {
            toast.error(await apiError(e));
        }
    }, [view, date, month]);
    useEffect(() => { load(); }, [load]);

    const act = async (action, body = {}, rd = date) => {
        setBusy(true);
        try {
            await api.post(`/reporting/group-closings/${rd}/${action}`, body);
            toast.success({ approve: "Closing disetujui dan dikunci", reopen: "Closing dibuka ulang", verify: "Verifikasi diperbarui" }[action]);
            await load();
        } catch (e) {
            toast.error(await apiError(e));
        } finally {
            setBusy(false);
        }
    };
    const approveRow = (rd) => window.confirm(`Setujui dan kunci closing tanggal ${rd}?`) && act("approve", {}, rd);
    const open = (rd) => { setDate(rd); setView("daily"); };
    const older = daily?.outstanding_before || 0;

    return (
        <div className="space-y-5" data-testid="executive-dashboard">
            <div className="flex flex-wrap items-center gap-3">
                <div className="inline-flex bg-white border border-mist rounded-sm p-0.5" data-testid="dash-view-switch">
                    {VIEWS.map(([k, l]) => (
                        <button key={k} type="button" onClick={() => setView(k)} data-testid={`dash-view-${k}`}
                            className={`px-3 md:px-4 py-2 text-xs uppercase tracking-widest rounded-sm transition-colors ${view === k ? "bg-ink text-white" : "text-neutral-500 hover:text-ink"}`}>
                            {l}{k === "pending" && pending?.length ? ` · ${pending.length}` : ""}
                        </button>
                    ))}
                </div>
                {view === "daily" && <input type="date" value={date} max={todayWIB()} onChange={(e) => e.target.value && setDate(e.target.value)} className={`${inp} !w-48`} data-testid="dash-date" />}
                {view === "monthly" && <input type="month" value={month} max={todayWIB().slice(0, 7)} onChange={(e) => e.target.value && setMonth(e.target.value)} className={`${inp} !w-48`} data-testid="dash-month" />}
            </div>
            {view === "daily" && older > 0 && (
                <button type="button" onClick={() => setView("pending")} className="w-full text-left flex items-center gap-2 bg-amber-50 border border-amber-200 text-amber-900 text-sm px-4 py-3 rounded-sm" data-testid="dash-older-banner">
                    <WarningCircle size={18} /> {older} tanggal sebelumnya belum disetujui — tinjau closing yang belum selesai
                </button>
            )}
            {view === "daily" && daily && daily.date === date && <DashDaily data={daily} act={act} busy={busy} />}
            {view === "daily" && <Outstanding items={pending} onOpen={open} onApprove={approveRow} busy={busy} compact />}
            {view === "monthly" && monthly && <DashMonthly data={monthly} />}
            {view === "pending" && <Outstanding items={pending} onOpen={open} onApprove={approveRow} busy={busy} />}
        </div>
    );
}
